import { render, staticRenderFns } from "./TruckItem.vue?vue&type=template&id=688ec80e&scoped=true&"
import script from "./TruckItem.vue?vue&type=script&lang=js&"
export * from "./TruckItem.vue?vue&type=script&lang=js&"
import style0 from "./TruckItem.vue?vue&type=style&index=0&id=688ec80e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ec80e",
  null
  
)

export default component.exports